document.addEventListener('DOMContentLoaded', function () {
    // Clear filters button
    const clearButton = document.querySelector('.clear-filter-btn');
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        const baseUrl = window.location.origin + window.location.pathname;
        window.location.href = baseUrl;
      });
    }

    // Handle sort changes
    const sortSelect = document.querySelector('.sort__select');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('sort_by', this.value);
        window.location.href = currentUrl.toString();
      });
    }

    // Handle filter changes
    const filterLinks = document.querySelectorAll('.js-remove-filter, .js-pagination-link');
    filterLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const url = this.getAttribute('href');
        if (url) {
          window.location.href = url;
        }
      });
    });

    // Handle filter form submission
    const filterForm = document.querySelector('.js-form');
    if (filterForm) {
      filterForm.addEventListener('submit', function(e) {
        e.preventDefault();
        const formData = new FormData(this);
        const searchParams = new URLSearchParams(formData);
        const currentUrl = new URL(window.location.href);
        currentUrl.search = searchParams.toString();
        window.location.href = currentUrl.toString();
      });
    }
	const header = document.querySelector('.collection__header');
	const stickyOffset = header.offsetTop;
	let isSticky = false;

	function handleScroll() {
	const scrollY = window.scrollY;
	const shouldStick = scrollY > stickyOffset;

	if (shouldStick && !isSticky) {
		header.classList.add('is-sticky');
		isSticky = true;
	} else if (!shouldStick && isSticky) {
		header.classList.remove('is-sticky');
		isSticky = false;
	}
	}

	function checkAndBindSticky() {
		const isWideScreen = window.innerWidth >= 1201;

		if (isWideScreen) {
			window.addEventListener('scroll', handleScroll);
		} else {
			window.removeEventListener('scroll', handleScroll);
			header.classList.remove('is-sticky'); // reset if it was applied
			isSticky = false;
		}
	}
	// Run once at load
	checkAndBindSticky();

	// Also listen for resize in case screen size changes
	window.addEventListener('resize', checkAndBindSticky);


  });